@if (!isOnline()) {
  <div class="connectivity-banner connectivity-banner--offline" role="status" aria-live="polite">
    <span class="material-symbols-outlined connectivity-banner__icon">wifi_off</span>
    <div>
      <span class="connectivity-banner__title">Sin conexión.</span>
      <span class="connectivity-banner__text">
        El dispositivo no tiene conexión a internet.
      </span>
    </div>
  </div>
} @else if (showReconnectedBanner()) {
  <div class="connectivity-banner connectivity-banner--online" role="status" aria-live="polite">
    <span class="material-symbols-outlined connectivity-banner__icon">wifi</span>
    <div>
      <span class="connectivity-banner__title">Conectado.</span>
      <span class="connectivity-banner__text">
        
      </span>
    </div>
  </div>
}
